import React from "react";
import ReactDOM from "react-dom";
import Loader from "../Loader";
import Select from "react-select";
import tipos from "../MapaRevendaLocacao/tipos";
const apiUrl = import.meta.env.VITE_API_MR_CRAWLER_URL;
import Table from "./Table";
import * as formatacoes from '../../util/formatacoes';

class Index extends React.Component {
    state = {
        user: [],
        estadosOptions: [],
        cidadesOptions: [],

        periodGt: "",
        periodLt: "",
        estados: [],
        cidades: [],
        tipo: [],
        tipo_negocio: [],
        loading: false,

        errors: [],
        data: null,
    };

    componentDidMount = async () => {
        try {
            await Promise.all([this.loadAuthUser(), this.loadEstados()]);

        } catch (e) {
            console.log(e);
        }
    }

    loadAuthUser = async () => {
        try {
            const response = await axios.get(route('user.auth'));
            this.setState({ user: response.data });
        } catch (e) {
            console.log(e);
        }
    };

    loadEstados = async () => {
        try {
            let response = await axios.get(route('web.todos_estados.index'));
            this.setState({ estadosOptions: response.data });
        } catch (e) {
            console.log(e);
        }
    }

    loadCidades = async () => {
        try {
            if (this.state.estados.length === 0) { return }

            this.setLoading(true);

            let siglasEstados = this.state.estados.map(estado => estado.value);

            let response = await axios.post(route('web.cidades_por_estado.index'), { estados: siglasEstados });

            this.setState({
                cidadesOptions: [
                    { value: "Todos", label: "Selecionar Todos" },
                    ...response.data
                ]
            });

        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    setLoading = (loading) => { this.setState({ loading: loading }) }


    submit = async () => {

        await this.validate();

        await this.setState({ data: null });

        this.setLoading(true);


        const payload = {
            periodGt: this.state.periodGt,
            periodLt: this.state.periodLt,
            estados: this.state.estados.map((estado) => estado.value),
            cidades: this.state.cidades.map((cidade) => cidade.label),
            tipo: this.state.tipo.map((tipo) => tipo.value),
            tipo_negocio: this.state.tipo_negocio.map((tipo_negocio) => tipo_negocio.value),
        };

        axios.get(`${apiUrl}api/contagem-amostra`, { params: payload })
            .then(async (response) => { await this.setState({ data: response.data }) })
            .catch(async (error) => { await this.setState({ errors: error.response.data.errors }); })
            .finally(() => { this.setLoading(false); })

    };
    clear = async () => {

        await this.setState({
            periodGt: "",
            periodLt: "",
            estados: [],
            cidades: [],
            tipo: [],
            tipo_negocio: [],
            loading: false,
            errors: [],
            data: null,
        })
    };


    validate = async () => {

        let errors = {};

        if (!this.state.periodGt) {
            errors['periodGt'] = ['O campo período inicial é obrigatório'];
        }

        if (Object.keys(errors).length > 0) {
            await this.setState({ errors: errors });

            throw new Error('Validation Error');
        }

    }
    render = () => {
        return (
            <>
                <div>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="form-group col-4">
                                    <label>Período Inícial</label>
                                    <input
                                        type="month"
                                        name="periodGt"
                                        value={this.state.periodGt}
                                        onChange={async (value) => { await this.setState({ periodGt: value.target.value }) }}
                                        style={{ padding: "3px" }}
                                        className="form-control"
                                    />
                                    {this.state.errors['periodGt'] &&
                                        <div className="invalid-feedback" style={{ display: "block" }}>
                                            {this.state.errors['periodGt'][0]}
                                        </div>}
                                </div>
                                <div className="form-group col-4">
                                    <label>Período Final</label>
                                    <input
                                        type="month"
                                        name="periodLt"
                                        value={this.state.periodLt}
                                        onChange={async (value) => await this.setState({ periodLt: value.target.value })}
                                        style={{ padding: "3px" }}
                                        className="form-control"
                                    />
                                    {this.state.errors['periodLt'] &&
                                        <div className="invalid-feedback" style={{ display: "block" }}>
                                            {this.state.errors['periodLt'][0]}
                                        </div>}
                                </div>
                                <div className="form-group col-4">
                                    <label>Tipo</label>
                                    <Select
                                        placeholder="Selecione"
                                        isMulti={true}
                                        value={this.state.tipo}
                                        onChange={(value) => {
                                            if (value == null) { value = []; }

                                            if (value.some((item) => item.value == "Todos")) {
                                                value = tipos.select_options;
                                            }

                                            this.setState({ tipo: value })
                                        }}
                                        options={[
                                            { value: "Todos", label: "Selecionar Todos", },
                                            ...tipos.select_options,
                                        ]}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <label>Tipo Negócio</label>
                                    <Select
                                        placeholder="Selecione"
                                        isMulti={true}
                                        value={this.state.tipo_negocio}
                                        onChange={(value) => {
                                            if (value == null) { value = []; }

                                            this.setState({ tipo_negocio: value })
                                        }}
                                        options={[
                                            { value: "VENDA", label: "Revenda", },
                                            { value: "ALUGUEL", label: "Aluguel", },
                                        ]}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <label>Estados</label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        name="estados"
                                        isMulti
                                        options={this.state.estadosOptions}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Selecione o Estado"
                                        value={this.state.estados}
                                        inputValue={this.state.inputEstadoValue ?? ""}
                                        onInputChange={(input) => this.setState({ inputEstadoValue: input })}
                                        filterOption={(option, input) => {
                                            if (!input) return true;

                                            const searchTerms = input.split(";").map(term => term.trim().toLowerCase());

                                            const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                            return searchTerms.some(term => lastTermIsEmpty ? option.label?.toLowerCase() == term : option.label?.toLowerCase().includes(term)
                                            );

                                        }}
                                        onChange={async (value) => {
                                            if (value == null) { value = []; }
                                            await this.setState({ estados: value });
                                            this.loadCidades();
                                        }}></Select>
                                </div>
                                <div className="form-group col-4">
                                    <label>Cidades</label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        name="cidades"
                                        isMulti
                                        options={this.state.cidadesOptions}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Selecione as cidades"
                                        value={this.state.cidades}
                                        inputValue={this.state.inputCidadeValue ?? ""}
                                        onInputChange={(input) => this.setState({ inputCidadeValue: input })}
                                        filterOption={(option, input) => {
                                            if (!input) return true;

                                            const searchTerms = input.split(";").map(term => term.trim().toLowerCase());

                                            const lastTermIsEmpty = searchTerms[searchTerms.length - 1] === "";

                                            return searchTerms.some(term => lastTermIsEmpty ? option.label?.toLowerCase() == term : option.label?.toLowerCase().includes(term)
                                            );

                                        }}
                                        onChange={async (value) => {
                                            if (value == null) { value = []; }
                                            if (value.some(item => item.value === 'Todos')) {
                                                value = [];
                                                this.state.cidadesOptions.map((index) => {
                                                    if (index.options != undefined) {
                                                        value = value.concat(index.options)
                                                    }
                                                })
                                            }
                                            await this.setState({ ...this.state, cidades: value });
                                        }}></Select>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-6">
                                    <button
                                        className="btn btn-sm btn-success btn-block"
                                        onClick={() => this.submit()}
                                    >
                                        <i className="fas fa-search"></i> Buscar
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button
                                        className="btn btn-sm btn-block"
                                        style={{ backgroundColor: "#FFBB27" }}
                                        onClick={() => this.clear()}
                                    >
                                        <i className="far fa-file"></i> Limpar
                                    </button>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loading && <Loader />}
                {this.state.data != null && <>

                    <div className="card">
                        <div className="card-body">
                            <div className="text-center">
                                <h3>Total de amostras {formatacoes.formatNumber(this.state.data['total'])}</h3>
                            </div>
                        </div>
                    </div>
                    <Table data={this.state.data} />
                </>}
            </>
        );
    };
}

export default Index;

if (document.getElementById("historicoRevendaLocacao")) {
    ReactDOM.render(<Index />, document.getElementById("historicoRevendaLocacao"));
}
